module.exports = __webpack_public_path__ + "static/media/blog-3.346a5970.jpg";